// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"ReferralChannel_errorMsg__GO2go"};